"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const StaticAlert_1 = __importDefault(require("./StaticAlert"));
const icons_1 = require("@material-ui/icons");
function StaticError(props) {
    const { errors = [], style = {} } = props;
    return (errors.length > 0 && (react_1.default.createElement(StaticAlert_1.default, { style: style, severity: "error", icon: react_1.default.createElement(icons_1.Error, null) },
        react_1.default.createElement("ul", null, errors.map((e, i) => e && react_1.default.createElement("li", { key: i }, e))))));
}
exports.default = StaticError;
